import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { ICrudGetAction, ICrudDeleteAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IVideoMetaDataKeywords } from 'app/shared/model/video-meta-data-keywords.model';
import { IRootState } from 'app/shared/reducers';
import { getEntity, deleteEntity } from './video-meta-data-keywords.reducer';

export interface IVideoMetaDataKeywordsDeleteDialogProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const VideoMetaDataKeywordsDeleteDialog = (props: IVideoMetaDataKeywordsDeleteDialogProps) => {
  useEffect(() => {
    props.getEntity(props.match.params.id);
  }, []);

  const handleClose = () => {
    props.history.push('/video-meta-data-keywords');
  };

  useEffect(() => {
    if (props.updateSuccess) {
      handleClose();
    }
  }, [props.updateSuccess]);

  const confirmDelete = () => {
    props.deleteEntity(props.videoMetaDataKeywordsEntity.id);
  };

  const { videoMetaDataKeywordsEntity } = props;
  return (
    <Modal isOpen toggle={handleClose}>
      <ModalHeader toggle={handleClose}>Confirm delete operation</ModalHeader>
      <ModalBody id="satshrutApp.videoMetaDataKeywords.delete.question">
        Are you sure you want to delete this VideoMetaDataKeywords?
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp; Cancel
        </Button>
        <Button id="jhi-confirm-delete-videoMetaDataKeywords" color="danger" onClick={confirmDelete}>
          <FontAwesomeIcon icon="trash" />
          &nbsp; Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = ({ videoMetaDataKeywords }: IRootState) => ({
  videoMetaDataKeywordsEntity: videoMetaDataKeywords.entity,
  updateSuccess: videoMetaDataKeywords.updateSuccess,
});

const mapDispatchToProps = { getEntity, deleteEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(VideoMetaDataKeywordsDeleteDialog);
